export default __webpack_public_path__ + "static/insta4-10205cd20ac32615ef019808058d9fed.jpg";